export const UNAVAILABLE_TIMES_DAYS_PRIOR = 1;
export const UNAVAILABLE_TIMES_DAYS_FOLLOWING = 2;
export const UNAVAILABLE_TIMES_MAX_DAYS_PRIOR = -1;
export const UNAVAILABLE_TIMES_MAX_DAYS_FOLLOWING = 3;
export const UNAVAILABLE_PRIOR_REASON = `Booking start time can only be at most ${UNAVAILABLE_TIMES_DAYS_PRIOR} days before the booking.`;
export const UNAVAILABLE_FOLLOWING_REASON = `Booking end time can only be at most ${UNAVAILABLE_TIMES_DAYS_FOLLOWING} days after the booking.`;



// WEBPACK FOOTER //
// ./scripts/constants/bookingUnavailability.js